import { render, staticRenderFns } from "./all-yu-jia-zai.vue?vue&type=template&id=fa2a3f52&scoped=true&"
import script from "./all-yu-jia-zai.vue?vue&type=script&lang=js&"
export * from "./all-yu-jia-zai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2a3f52",
  null
  
)

export default component.exports